module.exports = __webpack_public_path__ + "assets/img/block-left-hover-e7aeee5b.png";